import React from "react"
import TextArea from "../text-area"

const LargeTextArea = (props) => <TextArea {...props} large={true} rows="15" />

export default LargeTextArea
